import type { EstadoDeAcesso, QualidadePorEmail } from "../types";
import { ESTADOS, totalComProblema } from "./estados";

const contagemDe = (linha: QualidadePorEmail, estado: EstadoDeAcesso): number =>
  ESTADOS.find((item) => item.chave === estado)?.contagem(linha) ?? 0;

/** Clicar no card seleciona; clicar de novo no mesmo limpa. */
export const alternarEstado = (
  atual: EstadoDeAcesso | null,
  clicado: EstadoDeAcesso,
): EstadoDeAcesso | null => (atual === clicado ? null : clicado);

/**
 * Contas que a tabela mostra. O Thiago trabalha por conta de e-mail — abre o
 * e-mail e resolve as solicitações de gerenciamento de lá — então, filtrado um
 * estado, quem não tem nenhum perfil naquela situação só atrapalha.
 */
export const linhasVisiveis = (
  linhas: QualidadePorEmail[],
  estado: EstadoDeAcesso | null,
  busca: string,
): QualidadePorEmail[] => {
  const termo = busca.trim().toLowerCase();
  return linhas
    .filter((linha) => (estado ? contagemDe(linha, estado) > 0 : true))
    .filter((linha) => (termo ? (linha.email ?? "").toLowerCase().includes(termo) : true));
};

/** Filtrado, a coluna filtrada manda na ordem; sem filtro, quem tem mais problema sobe. */
export const ordemDaTabela = (
  linhas: QualidadePorEmail[],
  estado: EstadoDeAcesso | null,
): QualidadePorEmail[] =>
  [...linhas].sort((a, b) =>
    estado
      ? contagemDe(b, estado) - contagemDe(a, estado)
      : totalComProblema(b) - totalComProblema(a),
  );
